
const QR_SERVICE_URL = 'https://api.qrserver.com/v1/create-qr-code/';

/** Scheme per RFC 3986, e.g. `https://`, `tg4://`. */
const SCHEME_PREFIX = /^[a-z][a-z0-9+.-]*:\/\//i;
const WWW_PREFIX = /^www\./i;

export function qrCodeImageUrl(url: string, size = 500): string {
  return `${QR_SERVICE_URL}?size=${size}x${size}&data=${encodeURIComponent(url)}&margin=5`;
}

export function displayUrl(url: string): string {
  return url.replace(SCHEME_PREFIX, '').replace(WWW_PREFIX, '');
}
